<div class="max-w-1xl mx-auto bg-white p-8 rounded-lg shadow-lg">
  <div class="flex flex-row justify-between items-center mb-3">
    <div class="flex flex-row md:gap-3 items-center">
      <div class="flex flex-row flex-nowrap md:gap-3 items-center">
        <!-- <img class="left-arrow" src="../../../../assets/icons/left-arrow.svg"> -->
        <h1 class="headeradminui-text md:break-keep">
          Manage Events Ratings
        </h1>
      </div>
      <div>
        <img class="separator" src="../../../../assets/icons/separator.svg" />
      </div>
      <div>
        <h1 class="sub-headeradminui-text">{{ totalCount }} Total Ratings</h1>
      </div>
    </div>
    <!-- <div
    class="flex flex-row justify-between btn custom-btn-primary-adminui gap-1"
    [routerLink]="['/therapist/add']"
  >
    <div>
      <img class="add-icon" src="../../../../assets/icons/add-icon.svg" />
    </div>
    <div>
      <span class="">Add new therapist</span>
    </div>
  </div> -->
  </div>
  <div class="flex justify-end">
    <div class="w-[40%]">
      <nz-input-group nzSearch nzSize="large" [nzAddOnAfter]="suffixButton">
        <input
          type="text"
          nz-input
          [(ngModel)]="globalSearchInput"
          placeholder="Search for event,user name"
        />
      </nz-input-group>
    </div>
  </div>
  <ng-template #suffixButton>
    <button
      nz-button
      nzType="primary"
      nzSize="small"
      nzSearch
      (click)="searchGlobal()"
    >
      Search
    </button>
  </ng-template>
  <ng-template #tableHead>
    <div nz-row nzJustify="space-between">
      <div nz-col>
        <span class="font-bold">Events Rating</span>
      </div>
      <div nz-col>
        <nz-switch
          [(ngModel)]="testTherapistDisplay"
          (ngModelChange)="testTherapistChangeFn($event)"
          nzCheckedChildren="Hide Test Therapist"
          nzUnCheckedChildren="Show Test Therapist"
        ></nz-switch>
        <button
          class="ml-2"
          nz-button
          nzSize="small"
          nzType="primary"
          (click)="resetFilter()"
        >
          Clear filter
        </button>
      </div>
    </div>
  </ng-template>
  <nz-spin [nzSpinning]="pageLoading" nzTip="Fetching Events Rating......">
    <nz-table
      #therapistTable
      [nzTitle]="tableHead"
      [nzScroll]="{ y: '500px' }"
      class="mt-5"
      [nzData]="data"
      [nzShowPagination]="true"
      nzFrontPagination="false"
      [nzTotal]="totalCount"
      [nzPageSize]="pageSize"
      [nzBordered]="true"
      [nzShowSizeChanger]="true"
      [nzPageSizeOptions]="pageSizeOptions"
      [nzPageIndex]="currentPageNo"
      nzTableLayout="fixed"
      (nzPageIndexChange)="nzPageIndexChange($event)"
      (nzPageSizeChange)="nzPageSizeChange($event)"
    >
      <thead>
        <tr>
          <th>User Name</th>
          <th>
            Event Name
            <nz-filter-trigger [nzActive]="true" [nzDropdownMenu]="eventMenu">
              <span nz-icon nzType="filter"></span>
            </nz-filter-trigger>
          </th>
          <th
          (nzSortOrderChange)="sortTherapistRating($event)"
          nzShowSort="true"
          >Rating</th>
          <th>
            Partner Id
          </th>
          <th>Created At</th>
          <th nzWidth="30%">Questionaire</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of therapistTable.data">
          <td>
            {{ data.userName }}
          </td>
          <td>
            {{ data.eventName }}
          </td>
          <td>
            {{ data.rating }}
          </td>
          <td>
            {{ data.partnerId }}
          </td>
          <td>
            {{ utils.convertEpochToFormattedDate(data.createdAt) }}
          </td>
          <td>
            <ng-container
              *ngIf="
                data.questionnaire && objectKeys(data.questionnaire).length > 0;
                else noData
              "
            >
              <div class="font-bold">Question - Answer :</div>
              <div *ngFor="let entry of data.questionnaire | keyvalue">
                <strong>{{ entry.key }}</strong> - {{ entry.value }}
              </div>
            </ng-container>
            <ng-template #noData> N/A </ng-template>
          </td>
        </tr>

        <tr></tr>
      </tbody>
    </nz-table>
  </nz-spin>
</div>
<nz-dropdown-menu #eventMenu="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <div nz-row>
      <div nz-col>
        <span class="font-bold">Plans</span>
        <nz-divider></nz-divider>
        <nz-checkbox-wrapper (nzOnChange)="eventFilter($event)">
          <div *ngFor="let status of eventsCheckBoxOptions" nz-row>
            <div nz-col>
              <label
                nz-checkbox
                [nzValue]="status.value"
                [ngModel]="status.checked"
                >{{ status.label }}</label
              >
            </div>
          </div>
        </nz-checkbox-wrapper>
      </div>
    </div>
    <div nz-row nzJustify="end">
      <div nz-col>
        <button class="m-1" nz-button nzType="primary" (click)="getData()">
          Ok
        </button>
      </div>

      <div nz-col>
        <button class="m-1" nz-button nzType="primary" (click)="resetFilter()">
          Reset
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>
